var render = function render(){var _vm=this,_c=_vm._self._c;return _c('tci-solution',{attrs:{"subtitle":"","title":_vm.$t('solution.crm.title'),"images":_vm.$i18n.locale=="zh"?_vm.infos:_vm.infos_ja,"infos":_vm.$t('solution.crm.info')}})
}
var staticRenderFns = []

export { render, staticRenderFns }